import { AloftAreaJSON } from '@aloft/shared-objects';
import { syntaxFNMA } from '@aloft/toolkit-shared';

import { extractAdjustmentDescription } from './extractAdjustmentDescription.js';

export function extractGLA(sale: Element): AloftAreaJSON | undefined {
  try {
    return syntaxFNMA.grossLivingAreaSyntax
      .decode(extractAdjustmentDescription(sale, 'GrossLivingArea', 'GrossBuildingArea') ?? '')
      .toJSON();
  } catch (e: unknown) {
    console.warn('Failed to parse gla', e);
    return undefined;
  }
}
